const heroStats: { value: string; label: string }[] = [
  { value: '1993', label: '香港上映' },
  { value: '3 部', label: '系列作品' },
  { value: '11 位', label: '演员阵容' },
  { value: 'Ⅲ 级', label: '影片分级' },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20peach%20amber%20sunset%20glow%2C%20soft%20film%20grain%2C%20dreamy%201990s%20Hong%20Kong%20cinema%20mood%2C%20silhouette%20of%20city%20skyline%20and%20sea%20at%20dusk%2C%20moody%20artistic%20texture%2C%20rich%20warm%20tones%2C%20no%20text&width=1920&height=1080&seq=peach-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/75" />

      <div className="relative z-10 mx-auto flex w-full max-w-[1180px] flex-col items-center px-4 pb-16 pt-40 text-center md:px-6 md:pb-24 md:pt-48">
        <span className="fade-up inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/15 px-4 py-1.5 font-label text-xs text-primary-100 md:text-sm">
          <i className="ri-vip-crown-2-line text-accent-300" />
          1993 香港都市爱情剧情片 · 观影档案
        </span>

        <h1
          className="fade-up mt-6 font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl"
          style={{ animationDelay: '0.1s' }}
        >
          蜜桃成熟时电影
        </h1>

        <p
          className="fade-up mt-3 font-heading text-lg text-primary-100 md:text-2xl"
          style={{ animationDelay: '0.2s' }}
        >
          剧情全解 · 演员表 · 系列续集 · 类似电影推荐
        </p>

        <p
          className="fade-up mt-6 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base"
          style={{ animationDelay: '0.3s' }}
        >
          想了解这部 1993 年经典港片的来龙去脉？本页把完整的剧情脉络、演员阵容、系列续集信息，以及同类电影与经典片段推荐集中在一处，帮你在观影前快速掌握影片背景，做出自己的选择。
        </p>

        <div className="fade-up mt-8 flex flex-col items-center gap-3 sm:flex-row" style={{ animationDelay: '0.4s' }}>
          <a
            href="#plot"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-book-open-line" />
            阅读完整剧情
          </a>
          <a
            href="#cast"
            className="inline-flex items-center gap-2 rounded-md border border-background-100/40 bg-white/10 px-6 py-3 font-label text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-white/20"
          >
            <i className="ri-group-line" />
            查看演员表
          </a>
        </div>

        <dl className="fade-up mt-12 grid w-full grid-cols-2 gap-3 md:grid-cols-4 md:gap-4" style={{ animationDelay: '0.5s' }}>
          {heroStats.map((stat) => (
            <div key={stat.label} className="rounded-lg border border-background-100/15 bg-white/5 px-4 py-4 backdrop-blur-sm">
              <dt className="font-heading text-xl font-semibold text-accent-300 md:text-2xl">{stat.value}</dt>
              <dd className="mt-1 font-label text-xs text-background-100/75 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}